// src/pages/AdminDashboard.jsx
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, Newspaper, ShoppingBag, Radio, Star, ArrowRight } from 'lucide-react';
import { AuthContext } from '../AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
const font = { mono: '"JetBrains Mono", monospace', condensed: '"Barlow Condensed", sans-serif', body: '"Barlow", sans-serif' };

const AdminDashboard = () => {
  const { authToken } = useContext(AuthContext);
  const navigate      = useNavigate();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    fetch(`${BACKEND_URL}/api/admin/stats`, { headers: { Authorization: `Bearer ${authToken}` } })
      .then(r => r.json()).then(setStats).catch(() => {});
  }, [authToken]);

  const STAT_CARDS = [
    { label: 'Total Members',      value: stats?.users,              icon: Users,       to: '/admin/users',    color: '#fff' },
    { label: 'News Articles',      value: stats?.news,               icon: Newspaper,   to: '/admin/news',     color: '#fff' },
    { label: 'Store Products',     value: stats?.products,           icon: ShoppingBag, to: '/admin/store',    color: '#fff' },
    { label: 'Featured Streamers', value: stats?.featured_streamers, icon: Radio,       to: '/admin/live',     color: '#ff4444' },
  ];

  const QUICK_ACTIONS = [
    { label: 'Write a News Article', icon: Newspaper,   to: '/admin/news' },
    { label: 'Add a Product',        icon: ShoppingBag, to: '/admin/store' },
    { label: 'Set BGN Spotlight',    icon: Star,        to: '/admin/spotlight' },
    { label: 'Feature a Streamer',   icon: Radio,       to: '/admin/live' },
  ];

  return (
    <div style={{ padding: '2.5rem' }}>
      <div style={{ fontFamily: font.mono, fontSize: '0.58rem', color: '#333', letterSpacing: '0.2em', marginBottom: 6 }}>// OVERVIEW</div>
      <div style={{ fontFamily: font.condensed, fontWeight: 900, fontSize: '2.5rem', letterSpacing: '-0.02em', marginBottom: '2.5rem' }}>Dashboard</div>

      {/* Stats */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 1, background: '#111', border: '1px solid #111', marginBottom: '3rem' }}>
        {STAT_CARDS.map(({ label, value, icon: Icon, to, color }) => (
          <div
            key={label}
            onClick={() => navigate(to)}
            style={{ background: '#000', padding: '1.5rem', cursor: 'pointer' }}
            onMouseEnter={e => e.currentTarget.style.background = '#0d0d0d'}
            onMouseLeave={e => e.currentTarget.style.background = '#000'}
          >
            <Icon size={16} color={color} style={{ marginBottom: '0.75rem' }} />
            <div style={{ fontFamily: font.condensed, fontWeight: 900, fontSize: '2rem', letterSpacing: '-0.02em', color }}>{value ?? '—'}</div>
            <div style={{ fontFamily: font.mono, fontSize: '0.58rem', color: '#444', letterSpacing: '0.1em', marginTop: 4, textTransform: 'uppercase' }}>{label}</div>
          </div>
        ))}
      </div>

      {/* Quick actions */}
      <div style={{ fontFamily: font.mono, fontSize: '0.58rem', color: '#333', letterSpacing: '0.2em', marginBottom: '1rem' }}>// QUICK ACTIONS</div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '0.75rem' }}>
        {QUICK_ACTIONS.map(({ label, icon: Icon, to }) => (
          <div
            key={label}
            onClick={() => navigate(to)}
            style={{ background: '#0d0d0d', border: '1px solid #111', padding: '1.1rem 1.25rem', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between', transition: 'border-color 0.15s' }}
            onMouseEnter={e => e.currentTarget.style.borderColor = '#333'}
            onMouseLeave={e => e.currentTarget.style.borderColor = '#111'}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <Icon size={14} color="#fff" />
              <span style={{ fontFamily: font.mono, fontSize: '0.65rem', color: '#aaa', letterSpacing: '0.05em' }}>{label}</span>
            </div>
            <ArrowRight size={13} color="#333" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminDashboard;